import api from '@api';
import { call, put, takeEvery, select, SelectEffect } from 'redux-saga/effects';
import {
    validateFileImportFetch as validateFileImportFetchAction,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importFileImportFetchSuccess,
    importFileImportFetchFailure,
} from './reducer';
import { FileImportType, ImportFileImportResType, ValidateFileImportResType } from 'src/types/productsImport';
import { FileType } from 'src/types/file';
import translate from '@translate';
import { RootStoreType } from 'src/types/store';

export function* addFile(action: { type: string; payload: FileType }): any {
    yield put(validateFileImportFetchAction(action.payload));
}

export function* addFileWatch() {
    yield takeEvery('productsImport/addFile', addFile);
}

const validateFileImportFetchRequest = async (data: string) => {
    const res = await api('post', `api/secure/products/import-validate`, { data });
    return res.data.data;
};

function* validateFileImportFetch(action: { type: string; payload: FileType }) {
    try {
        const response: ValidateFileImportResType = yield call((): any =>
            validateFileImportFetchRequest(action.payload.data || '')
        );
        yield put(validateFileImportFetchSuccess({ validation: response, file: action.payload }));
    } catch (e) {
        yield put(
            validateFileImportFetchFailure({ file: action.payload, errorMessage: e?.response?.data?.message || '' })
        );
    }
}

export function* validateFileImportFetchWatch() {
    yield takeEvery('productsImport/validateFileImportFetch', validateFileImportFetch);
}

export function selectState<T>(selector: (s: RootStoreType) => T): SelectEffect {
    return select(selector);
}

const importFileImportFetchRequest = async (data: (string | undefined)[]) => {
    const res = await api('post', `api/secure/products/import-products`, { data });
    return res.data.data;
};

function* importFileImportFetch() {
    try {
        const files: FileImportType[] = yield select((state: RootStoreType) => state.productsImport.files);
        const filesData = files.filter((file) => !file.imported).map((file) => file.file.data);
        const response: ImportFileImportResType = yield call((): any => importFileImportFetchRequest(filesData));
        yield put(
            importFileImportFetchSuccess({
                imported: response,
                messageSuccess: { title: translate('products.message.productImported') },
            })
        );
    } catch (e) {
        yield put(importFileImportFetchFailure({ errorMessage: e?.response?.data?.message || '' }));
    }
}

export function* importFileImportFetchWatch() {
    yield takeEvery('productsImport/importFileImportFetch', importFileImportFetch);
}
